import connectionService from '@services/internal/connection.service';
import { memberApiV2 } from 'lib/api';
import { takeLatest, takeLeading } from 'redux-saga/effects';
import { call, put } from 'typed-redux-saga/macro';
import { connectCb } from '../../helpers/strophe-helpers';
import { actions as xmppActions } from '../ducks/xmpp';

function* connectionRequest(_: ReturnType<typeof xmppActions.connectionRequest>) {
  try {
    const credentials = (yield* call(memberApiV2.getXmppCredentials)).data;
    const { jabberId, jabberPassword } = credentials.data;

    const status = yield* call(connectionService.connect, jabberId, jabberPassword);
    const connection = yield* call(connectionService.waitForConnection);
    yield* call(connectCb, status, connection);
  } catch {
    console.log('xmpp connection failed');
  }
}

function* disconnectRequest(_: ReturnType<typeof xmppActions.disconnectRequest>) {
  try {
    yield* call(connectionService.disconnectAndDestroy);
    yield* put(xmppActions.setStatus('DISCONNECTED'));
  } catch {
    console.log('xmpp disconnection failed');
  }
}

function* xmppSaga() {
  yield takeLatest(xmppActions.connectionRequest, connectionRequest);
  yield takeLeading(xmppActions.disconnectRequest, disconnectRequest);
}

export default xmppSaga;
